import React, { Component } from 'react';
import WeekComponent from '../week/Week';
import TestComponent from '../test/test';
import moment from 'moment';
import DayPicker from 'react-day-picker';
import {Helmet} from "react-helmet";

function getWeekDays(weekStart) {
    const days = [weekStart];
    for (let i = 1; i < 7; i += 1) {
      days.push(
        moment(weekStart)
          .add(i, 'days')
          .toDate()
      );
    }
    return days;
  }
  
  function getWeekRange(date) {
    return {
      from: moment(date)
        .startOf('isoWeek')
        .toDate(),
      to: moment(date)
        .endOf('isoWeek')
        .toDate(),
    };
  }

class Dashboard extends Component {
    constructor(props){
        super(props);
        this.handleBarChartClick = this.handleBarChartClick.bind(this);
        this.handleWeekNrChange = this.handleWeekNrChange.bind(this);
    }

   
    
    state = {
        date : {},
        weekDay : "",
        weekNr : parseInt(moment().format('WW')),
        year : parseInt(moment().format('YYYY')),
        hoverRange: undefined,
        selectedDays: [],
        ip: "172.16.135.126"//"192.168.0.122"
    }

    handleDayChange = date => {
        this.setState({
          selectedDays: getWeekDays(getWeekRange(date).from),
        });
        let wNr = moment(date).format('WW');
        let yr = moment(date).format('YYYY');
        this.props.handleWeekChange(yr, wNr)
        this.setState({
            weekNr : moment(date).format('WW'),
            year : moment(date).format('YYYY')
        })
        const titleElement = document.getElementById('week-wrapper')
        titleElement.scrollIntoView({ behavior: 'smooth' })
      };

      componentDidUpdate(prevProps){
        if(prevProps.selectedDays !== this.props.selectedDays) {
          this.setState({
              selectedDays : this.props.selectedDays
          })
      }
      else {
      if (prevProps.weekNr !== this.props.weekNr) {
          this.setState({
            selectedDays : this.props.selectedDays
          });
      }
      }
    }
    
      handleDayEnter = date => {
        this.setState({
          hoverRange: getWeekRange(date),
        });
      };
    
      handleDayLeave = () => {
        this.setState({
          hoverRange: undefined,
        });
      };
    
      handleWeekClick = (weekNumber, days, e) => {
        this.setState({
          selectedDays: days,
        });
      };

    handleWeekNrChange(weekNr){
        this.setState({ weekNr });
    }
    
    handleBarChartClick(item, color) {
        this.setState({item, color: color});
    }

    render(){
        const { hoverRange, selectedDays } = this.state;
        const selectedDays2 = this.props.selectedDays;
        const daysAreSelected = false;
        if (this.props.selectedDays2 !== undefined){
          daysAreSelected = selectedDays.length > 0;
        } 
        const modifiers = {
            hoverRange,
            selectedRange: daysAreSelected && {
            from: selectedDays[0],
            to: selectedDays[6],
            },
            hoverRangeStart: hoverRange && hoverRange.from,
            hoverRangeEnd: hoverRange && hoverRange.to,
            selectedRangeStart: daysAreSelected && selectedDays[0],
            selectedRangeEnd: daysAreSelected && selectedDays[6],
        };
        return(
            <div>
              <article></article>
                <div className="SelectedWeekExample" >
                    <DayPicker 
                    selectedDays={selectedDays}
                    firstDayOfWeek={1}
                    month={this.state.selectedDays.length > 1 ? new Date(selectedDays[0]) : new Date()}
                    showWeekNumbers
                    showOutsideDays
                    modifiers={modifiers}
                    onDayClick={this.handleDayChange}
                    onDayMouseEnter={this.handleDayEnter}
                    onDayMouseLeave={this.handleDayLeave}
                    onWeekClick={this.handleWeekClick}
                    />
                </div>
                {selectedDays.length === 7 && (
                <div className="WeekDescription">
                    <p>{moment(selectedDays[0]).format('LL')} –{' '}
                    {moment(selectedDays[6]).format('LL')}</p>
                </div>
                )}
                 <Helmet>
                    <style>{`
                        .SelectedWeekExample .DayPicker-Month {
                        border-collapse: separate;
                        }
                        .SelectedWeekExample .DayPicker-WeekNumber {
                        outline: none;
                        }
                        .SelectedWeekExample .DayPicker-Day {
                        outline: none;
                        border: 1px solid transparent;
                        }
                        .SelectedWeekExample .DayPicker-Day--hoverRange {
                        background-color: #EFEFEF !important;
                        }

                        .SelectedWeekExample .DayPicker-Day--selectedRange {
                        background-color: #fff7ba !important;
                        border-top-color: #FFEB3B;
                        border-bottom-color: #FFEB3B;
                        border-left-color: #fff7ba;
                        border-right-color: #fff7ba;
                        }

                        .SelectedWeekExample .DayPicker-Day--selectedRangeStart {
                        background-color: #e6261f !important;
                        border-left: 1px solid #e6261f;
                        }

                        .SelectedWeekExample .DayPicker-Day--selectedRangeEnd {
                        background-color: #4355db !important;
                        border-right: 1px solid #4355db;
                        }

                        .SelectedWeekExample .DayPicker-Day--selectedRange:not(.DayPicker-Day--outside).DayPicker-Day--selected,
                        .SelectedWeekExample .DayPicker-Day--hoverRange:not(.DayPicker-Day--outside).DayPicker-Day--selected {
                        border-radius: 0 !important;
                        color: black !important;
                        }
                        .DayPicker-Week {
                          height: 40px
                        }
                        .DayPicker {
                          font-size: 1.2rem;
                        }
                    `}
                </style>
        </Helmet>
        {/* {this.state.selectedDays.length !== 0 ?  */}
          <WeekComponent
            
            weekNr2={this.props.week2}
            weekNr={this.props.week2}
            year={this.props.year2}
            year2={this.props.year2}
            handleWeekNrChange={this.handleWeekNrChange}
            handleBarChartClick={this.handleBarChartClick}
            ip={this.state.ip}
          />
        {/* : <h1 className="WeekLoaderText">Select a week to see stats for that week</h1>} */}
              
              <TestComponent 
                  date={this.state.item}
                  color={this.state.color}
                  ip={this.state.ip}
              /> 
          </div>
            
        )
    }



}

export default Dashboard;